/**
 * HUB-H — Filtres sévérité audit.
 */
import React from 'react';
import { SEVERITY_META } from '../../utils/equipe/equipeDisplay';

const FILTERS = [
  { key: '', label: 'Tous' },
  { key: 'info', label: SEVERITY_META.info.label },
  { key: 'warning', label: SEVERITY_META.warning.label },
  { key: 'critical', label: SEVERITY_META.critical.label },
];

export default function ActiviteEquipeSeverityFilters({ value, onChange }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-equipe-severity-filters">
      {FILTERS.map((filter) => {
        const isActive = value === filter.key;
        return (
          <button
            key={filter.key || 'all'}
            type="button"
            onClick={() => onChange(filter.key)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-equipe-severity-${filter.key || 'all'}`}
          >
            {filter.label}
          </button>
        );
      })}
    </div>
  );
}
